import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { Wrapper } from '@/components/Hypertracker/HyperSearch/HyperSearchStyled';

interface VariantProps {
    $isHeader: boolean;
    $isFocused: boolean;
}

const shouldForwardProp = (prop: string) => prop !== '$isHeader' && prop !== '$isFocused';

export const SearchWrapper = styled(Wrapper, { shouldForwardProp })<VariantProps>(
    ({ $isHeader, $isFocused }) => ({
        width: $isHeader ? ($isFocused ? '80%' : '95px') : '100%',
        gap: $isHeader ? undefined : '10px',
        transition: $isHeader ? 'width 0.4s ease' : undefined,
    }),
);

export const SearchField = styled(TextField, { shouldForwardProp })<VariantProps>(
    ({ theme, $isHeader, $isFocused }) => ({
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'transparent',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderRadius: '28px',
                transition: 'none',
            },
            '&:hover fieldset': $isHeader
                ? {
                      borderColor: theme.palette.hyperLiquidColor,
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      transition: 'none',
                  }
                : { borderColor: 'transparent' },
            '&.Mui-focused fieldset': $isHeader
                ? {
                      borderColor: theme.palette.hyperLiquidColor,
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      outline: 'none',
                      transition: 'none',
                      boxShadow: 'none',
                  }
                : { borderColor: 'transparent', outline: 'none', boxShadow: 'none' },
            borderRadius: '28px',
            backgroundColor:
                $isHeader && $isFocused ? theme.palette.backgrounds.bg3 : 'transparent',
            outline: 'none',
            boxShadow: 'none',
        },
        '& .MuiInputBase-input': {
            WebkitAppearance: 'none',
            boxShadow: 'none',
            '&:focus': {
                outline: 'none',
                boxShadow: 'none',
            },
            '&::placeholder': {
                color:
                    $isFocused || !$isHeader
                        ? theme.palette.customText.text1
                        : theme.palette.common.white,
                opacity: 1,
                fontSize: $isHeader ? '12px' : '14px',
                fontWeight: 600,
            },
        },
        '& .MuiInputBase-root': {
            height: $isHeader ? '32px' : '40px',
            outline: 'none',
            boxShadow: 'none',
        },
    }),
);

export const SubmitButtonContainer = styled(Box)({
    width: 'min-content',
});
